/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Back_To_ListeningInputs */

const en_dialog_back_to_listening = /** @type {(inputs: Dialog_Back_To_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`back to listening`)
};

const es_dialog_back_to_listening = /** @type {(inputs: Dialog_Back_To_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`volver a escuchar`)
};

/**
* | output |
* | --- |
* | "back to listening" |
*
* @param {Dialog_Back_To_ListeningInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_back_to_listening = /** @type {((inputs?: Dialog_Back_To_ListeningInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Back_To_ListeningInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_back_to_listening(inputs)
	return en_dialog_back_to_listening(inputs)
});